/**
 * DOM element helpers for querying and checking element attributes
 * 
 * This module provides utilities for:
 * - Getting structure and parameter indices from elements
 * - Type checking for variable spans and paragraph rows
 * - Querying elements by data attributes
 */

import {DATA_ATTRIBUTES, SELECTORS} from './constants';

export function getStructureIndex(element: Element | null): number {
    if(!element) return 0;
    const value = element.getAttribute(DATA_ATTRIBUTES.STRUCTURE_INDEX);
    return value ? parseInt(value, 10) : 0;
}

export function getParamIndex(element: Element | null): number | null {
    if(!element) return null;
    const value = element.getAttribute(DATA_ATTRIBUTES.PARAM_INDEX);
    return value !== null ? parseInt(value, 10) : null;
}

export function isVariableSpan(node: Node): boolean {
    return node.nodeType === Node.ELEMENT_NODE && 
           (node as Element).hasAttribute(DATA_ATTRIBUTES.LABEL);
}

export function isParagraphRow(element: Element): boolean {
    return element.hasAttribute(DATA_ATTRIBUTES.STRUCTURE_INDEX) &&
           !element.hasAttribute(DATA_ATTRIBUTES.PARAM_INDEX);
}

export function queryByIndices(
    structureIndex: number, 
    paramIndex?: number,
    container: HTMLElement = document.body
): HTMLElement | null {
    const structureSelector = `[${DATA_ATTRIBUTES.STRUCTURE_INDEX}="${structureIndex}"]`;
    const paramSelector = paramIndex !== undefined 
        ? `[${DATA_ATTRIBUTES.PARAM_INDEX}="${paramIndex}"]` 
        : '';
    
    return container.querySelector(`${structureSelector}${paramSelector}`) as HTMLElement;
}

export function findParagraphAtIndex(
    structureIndex: number,
    container: HTMLElement = document.body
): HTMLElement | null {
    const candidates = Array.from(
        container.querySelectorAll(`[${DATA_ATTRIBUTES.STRUCTURE_INDEX}="${structureIndex}"]`)
    );
    
    return candidates.find(candidate => isParagraphRow(candidate)) as HTMLElement || null;
}

export function getAllEditableElements(container: HTMLElement = document.body): Element[] {
    return Array.from(container.querySelectorAll(SELECTORS.STRUCTURE_INDEX));
}
